import { gql } from '@apollo/client'

export const GET_ROUND_ROUTE_PRICE = gql`
    query GetRoundRoutePrice($page: PageInput!, $priceId: String) {
        getRoundRoutePrice(page: $page, price_id: $priceId) {
            code
            success
            message
            total_count
            round_prices {
                end_location {
                    id
                    name {
                        en
                        ar
                    }
                    country_details {
                        country_code
                        country
                        country_ar
                        is_gcc
                    }
                }
                end_location_id
                price_id
                start_location_id
                status {
                    code
                    description {
                        en
                        ar
                    }
                }
                status_code
                start_location {
                    id
                    name {
                        en
                        ar
                    }
                    country_details {
                        country_code
                        country
                        country_ar
                        is_gcc
                    }
                }
                price_details {
                    seat_type_code
                    seat_type {
                        code
                        description {
                            en
                            ar
                        }
                    }
                    price {
                        ADL
                        CHD
                        INF
                        SNR
                    }
                }
                seat_layout_id
                seat_layout {
                    layout_id
                    layout_key
                    num_rows
                    num_columns
                    seats_config {
                        seats {
                            row
                            column
                            seat_number
                            status {
                                code
                                description {
                                    en
                                    ar
                                }
                            }
                            user_audit {
                                created_by
                                created_date
                                modified_by
                                modified_date
                            }
                        }
                    }
                    description {
                        en
                        ar
                    }
                    user_audit {
                        created_by
                        created_date
                        modified_by
                        modified_date
                    }
                }
                user_audit {
                    created_by
                    created_date
                    modified_by
                    modified_date
                }
            }
        }
    }
`

// export const GET_ROUTE_STATUS = gql`
// query RoundTripPricetatus($code: String) {
//   roundTripPricetatus(code: $code) {
//     code
//     description {
//       en
//       ar
//     }
//   }
//   }

// input:
// {
//   "code": null
// }`
